import Vue from 'vue';
import moment from 'moment';
import store from './store';
import { initAbTestLayout } from './abTest';
import purchaseSheetApp from './purchase-sheep-app.vue';
import PriceTableApp from './price-table-app';
import CourseCarouselApp from './course-carousel-app';
import CourseBlogApp from './course-blog-app';
import BrandingApp from './branding-app';
import RouletteApp from './roulette-app';
import { initLayout } from './utils/layout-bundle';

const getCourseProps = (app, selector) => {
  const course = app.querySelectorAll(selector);
  let list = [...course].map((item) => item.dataset);
  const { reverseOrder } = app.dataset;
  if (reverseOrder && reverseOrder === 'true') return list.reverse();
  return list;
};

const initPurchaseSheetLayout = (layoutType) => {
  const [app] = document.getElementsByClassName('fc-floating-purchase-sheet');
  if (app) {
    const { buttonLabel } = app.dataset;
    const { pageId, courseId } = document.getElementById('main').dataset;
    const initProps = { props: { pageId, courseId, buttonLabel, layoutType } };
    new Vue({
      store,
      render: (h) => h(purchaseSheetApp, initProps),
    }).$mount(app);
  }
};

const initPriceTableLayout = (layoutType) => {
  const selector = `.${layoutType} .fc-price-table`;
  const apps = document.querySelectorAll(selector);
  const {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  } = document.getElementById('main').dataset;
  const mainProps = {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  };

  [...apps].forEach((app) => {
    const { buttonLabel } = app.dataset;
    const appProps = {
      buttonLabel,
    };

    if (app) {
      new Vue({
        store,
        render: (h) => h(PriceTableApp, { props: { ...mainProps, ...appProps } }),
      }).$mount(app);
    }
  });
};

const initCourseCarouselLayout = (layoutType) => {
  const selector = `.${layoutType} .container-fluid`;
  const apps = document.querySelectorAll(selector);
  const {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  } = document.getElementById('main').dataset;
  const mainProps = {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  };

  [...apps].forEach((app) => {
    if (app) {
      const courseProps = getCourseProps(app, '.carousel__card');

      new Vue({
        store,
        render: (h) => h(CourseCarouselApp, { props: { ...mainProps, ...app.dataset, courseProps } }),
      }).$mount(app);
    }
  });
};

const initCourseBlogLayout = (layoutType) => {
  const selector = `.${layoutType} .container-fluid`;
  const apps = document.querySelectorAll(selector);
  const {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  } = document.getElementById('main').dataset;
  const mainProps = {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  };

  [...apps].forEach((app) => {
    if (app) {
      const courseProps = getCourseProps(app, '.container__card');
      new Vue({
        store,
        render: (h) => h(CourseBlogApp, { props: { ...mainProps, ...app.dataset, courseProps } }),
      }).$mount(app);
    }
  });
};

// layoutType이 아닌 layerId or blockId로 변경해야...?
const initBranding = (layoutType) => {
  const $apps = document.getElementsByClassName(layoutType);

  [...$apps].forEach(($app) => {
    const props = $app.getElementsByClassName('container-fluid')[0].dataset;
    const { startDate, endDate } = props;
    const isActive = (showAt, hideAt) => moment().isBetween(showAt, hideAt);

    if (isActive(startDate, endDate)) {
      new Vue({
        render: (h) => h(BrandingApp, { props: { ...props } }),
      }).$mount($app.getElementsByClassName('container-fluid')[0]);
    } else {
      $app.style.display = 'none';
    }
  });
};

const initRoulette = (layoutType) => {
  const pageId = document.getElementById('main').dataset.pageId;
  const $apps = document.getElementsByClassName(layoutType);
  const layerCouponCodes = [...$apps].map(
    ($layout) => $layout.getElementsByClassName('container-fluid')[0].dataset.couponCode
  );

  [...$apps].forEach(($app) => {
    const couponCode = $app.getElementsByClassName('container-fluid')[0].dataset.couponCode;
    const couponCount = layerCouponCodes.filter((layerCouponCode) => layerCouponCode === couponCode).length;
    if (couponCount === 1) {
      const props = {
        ...$app.getElementsByClassName('container-fluid')[0].dataset,
        pageId,
      };

      new Vue({
        render: (h) => h(RouletteApp, { props }),
      }).$mount($app.getElementsByClassName('container-fluid')[0]);
    } else {
      const [$target] = $app.getElementsByClassName('container');
      $target.style.display = 'block';
      $target.style.fontSize = '5rem';
      $target.style.textAlign = 'center';
      $target.style.color = 'red';
      $target.innerText = '중복된 코드는 삽입할 수 없습니다.';
    }
  });
};

export const initComposedLayout = () => {
  initLayout('fc-layout-906');
  initPriceTableLayout('fc-layout-908');
  initPurchaseSheetLayout('fc-layout-909');
  initCourseCarouselLayout('fc-layout-215');
  initCourseBlogLayout('fc-layout-513');
  initBranding('fc-layout-910');
  initRoulette('fc-layout-911');
  initAbTestLayout();
};
